module.exports = __webpack_public_path__ + "static/media/19-13.cd49af35.mp3";